import React from 'react';
import SearchStationsView from '../../Views/AfterAuth/SearchStationsView';

const SearchStations = () => {
    return <SearchStationsView />;
};

export default SearchStations;
